import React from 'react'
import PropTypes from 'prop-types'
import { TEST_MODES } from './testFixtures'

const getModeConfig = (mode) => TEST_MODES.find(m => m.id === mode) || TEST_MODES[0]

function TestList ({ tests, selectedIndex, runningTests, onSelect, onRun, onRemove, classes }) {
  const getStatusClass = (status) => {
    if (status === 'passed') return classes.statusPassed
    if (status === 'failed') return classes.statusFailed
    return classes.statusNeutral
  }

  return (
    <div className={classes.testList}>
      {tests.map((test, index) => {
        const modeConfig = getModeConfig(test.testMode)
        const isRunning = runningTests.has(index)
        return (
          <div
            key={`${test.name}-${index}`}
            className={`${classes.testRow} ${selectedIndex === index ? classes.testRowSelected : ''}`}
            onClick={() => onSelect(index)}
          >
            {isRunning
              ? <span className={classes.statusIndicator} style={{ backgroundColor: 'var(--color-primary-400)', animation: 'pulse 1s infinite' }} />
              : <div className={`${classes.statusIndicator} ${getStatusClass(test.status)}`} />}
            <span
              className={classes.modeBadge}
              style={{ color: modeConfig.color, backgroundColor: modeConfig.bg }}
            >
              {modeConfig.label}
            </span>
            <span className={classes.testName}>{test.name}</span>
            {isRunning && <span className={classes.testMeta} style={{ color: 'var(--color-primary-500)' }}>running&hellip;</span>}
            {!isRunning && test.lastRunMs !== null && (
              <span className={classes.testMeta}>{test.lastRunMs}ms</span>
            )}
            <div className={classes.rowActions}>
              <button
                className={classes.iconBtn}
                title='Run test'
                aria-label={`Run ${test.name}`}
                disabled={isRunning}
                onClick={(e) => { e.stopPropagation(); onRun(index) }}
              >
                &#9654;
              </button>
              <button
                className={`${classes.iconBtn} ${classes.iconBtnDanger}`}
                title='Remove test'
                aria-label={`Remove ${test.name}`}
                onClick={(e) => { e.stopPropagation(); onRemove(index) }}
              >
                &times;
              </button>
            </div>
          </div>
        )
      })}
    </div>
  )
}

TestList.propTypes = {
  tests: PropTypes.array.isRequired,
  selectedIndex: PropTypes.number,
  runningTests: PropTypes.instanceOf(Set).isRequired,
  onSelect: PropTypes.func.isRequired,
  onRun: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default TestList
